import React from "react";

type NameHeadingProps = {
  name: string;
};

const NameHeading: React.FC<NameHeadingProps> = ({ name }) => {
  return (
    <div className="w-full max-w-full flex justify-center items-center mb-6 mt-4 px-4">
      <div className="text-center min-w-0">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800 dark:text-gray-100 mb-2 break-words">
          {name}
        </h1>
        <div className="h-1 w-24 bg-blue-500 dark:bg-blue-400 mx-auto rounded-full"></div>
      </div>
    </div>
  );
};

export default NameHeading;
